module.exports = __webpack_public_path__ + "static/media/mobMsgActive.9abfce0a.svg";